<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1>Sign Up</h1>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 mt-3>
        <form>
          <v-layout column>
            <v-flex>
              <v-text-field
                name="email"
                label="Email"
                id="email"
                type="email"
                required></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="password"
                label="Password"
                hint="At least 8 characters"
                id="password"
                min="8"
                :append-icon="password_visibility ? 'visibility' : 'visibility_off'"
                :append-icon-cb="() => (password_visibility = !password_visibility)"
                value="Password"
                :rules="[() => ('The email and password you entered don\'t match')]"
                error
                :type="password_visibility ? 'password' : 'text'"
              ></v-text-field>
            </v-flex>
            <v-flex class="text-xs-center" mt-5>
              <v-btn color="primary" type="submit">Submit</v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      password_visibility: true
    };
  }
};
</script>

<style scoped>
</style>
